<template>
    <Transition mode="out-in">
        <div v-if="type === 'username'">
            <UtilsLoginPhoneInput :is-loading="loading" @send-data="handleUsername" />
        </div>
        <div v-else-if="type === 'password'">
            <UtilsLoginPasswordInput
                :username="state.username"
                :is-loading="isLoading"
                @send-data="handlePassword"
                @change:type="handleChangeType"
            />
        </div>
    </Transition>
</template>

<script lang="ts" setup>
const emits = defineEmits(["send-data", "change:type", "update:type"]);

const props = defineProps({
    isLoading: {
        type: Boolean,
        default: false,
    },
});

type ModalType = "username" | "password";
interface ICredential {
    username: string | undefined;
    password: string | undefined;
}

const type: Ref<ModalType> = ref("username");
const loading = ref(false);

const state: ICredential = reactive({
    username: undefined,
    password: undefined,
});

async function handleUsername(e: string) {
    loading.value = true;
    state.username = e;
    await fetchData("/auth/authenticate", {
        method: "POST",
        useSanctum: true,
        body: {
            ...state,
        },
        onResponse({ response }) {
            if (isResponseSuccessful(response.status)) {
                state.username = response._data.username;
                if (response._data.has_account) {
                    if (response._data.login_method === "otp") {
                        emits("change:type", "otp", state.username);
                    } else if (response._data.has_password) {
                        type.value = "password";
                    } else {
                        emits("change:type", "otp", state.username);
                    }
                } else {
                    emits("change:type", "create", state.username);
                }
            }
        },
    }).then(() => {
        loading.value = false;
    });
}

function handleChangeType(t: "otp" | "username" | "forgot") {
    if (t === "username") {
        type.value = t;
    } else {
        emits("change:type", t, state.username);
    }
}

function handlePassword(e: string) {
    state.password = e;
    if (e) emits("send-data", state);
}
</script>

<style scoped>
.v-enter-active,
.v-leave-active {
    transition: all 0.5s ease;
}

.v-enter-from {
    opacity: 0;
    transform: translateX(50px);
}
.v-leave-to {
    opacity: 0;
    transform: translateX(-50px);
}
</style>
